import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1e8d4d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("数据总览")
const _hoisted_4 = { class: "cricle" }
const _hoisted_5 = { class: "cricle-box success" }
const _hoisted_6 = { class: "cricle-n" }
const _hoisted_7 = { class: "cricle-value" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cricle-label" }, "昨日扫码人数", -1))
const _hoisted_9 = { class: "percentage-value" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "percentage-label" }, "昨日转化率", -1))
const _hoisted_11 = { class: "percentage-value" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "percentage-label" }, "更换率", -1))
const _hoisted_13 = { class: "cricle-box warning" }
const _hoisted_14 = { class: "cricle-n" }
const _hoisted_15 = { class: "cricle-value" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cricle-label" }, "今日扫码人数", -1))
const _hoisted_17 = { class: "search" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_19 = { class: "table" }
const _hoisted_20 = { class: "top" }
const _hoisted_21 = { class: "span" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("查看详情")

import { onMounted, ref } from 'vue'
import { Search } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router'
import { getLatestAdv, getAllProduction,getAdvById } from '../config/interface'
import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const inputValue = ref('')
const analyObj = ref({
  transYesterday: 0,
  scanYesterday: 0,
  scanToday: 0,
  changeYesterday: 0,
  advSituation: {
    xuejieScanList: [],
    id: 0,
    advName: ''
  }
})
const selActive = ref(0)
const tableDate = ref([])
const productList = ref([{
  id:0,
  proName:''
}])

const router = useRouter()
const goAnalysis = () => {
  router.push({
    path: '/analysis',
    query: { id: analyObj.value.advSituation.id }
  })
}
const search = (()=>{
  if(!inputValue.value){
    ElMessage.error('请输入活动id')
    return
  }
  let params = {
    id:inputValue.value
  }
  getAdvById(params).then(res=>{
    if(res.data.success){
      tableDate.value = analyObj.value.advSituation.xuejieScanList
    }else{
      ElMessage.error(res.data.msg)
    }
  })
})
onMounted(() => {
  getLatestAdv({}).then(res => {
    analyObj.value = res.data.data
    selActive.value = res.data.data.advSituation.id
    tableDate.value = analyObj.value.advSituation.xuejieScanList
  })
  getAllProduction({}).then(res => {
    productList.value = res.data.data
  })
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_tag, {
        class: "ml-2",
        type: "success"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(analyObj.value.scanYesterday), 1),
          _hoisted_8
        ])
      ]),
      _createVNode(_component_el_progress, {
        type: "dashboard",
        percentage: analyObj.value.transYesterday
      }, {
        default: _withCtx(({ percentage }) => [
          _createElementVNode("span", _hoisted_9, _toDisplayString(percentage) + "%", 1),
          _hoisted_10
        ]),
        _: 1
      }, 8, ["percentage"]),
      _createVNode(_component_el_progress, {
        type: "dashboard",
        percentage: analyObj.value.changeYesterday,
        status: "exception"
      }, {
        default: _withCtx(({ percentage }) => [
          _createElementVNode("span", _hoisted_11, _toDisplayString(percentage) + "%", 1),
          _hoisted_12
        ]),
        _: 1
      }, 8, ["percentage"]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, _toDisplayString(analyObj.value.scanToday), 1),
          _hoisted_16
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_el_input, {
        modelValue: inputValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
        class: "w-50 m-2",
        placeholder: "活动id",
        "prefix-icon": _unref(Search),
        clearable: ""
      }, null, 8, ["modelValue", "prefix-icon"]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => [
          _hoisted_18
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_el_form, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "活动名称:" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_21, _toDisplayString(analyObj.value.advSituation.advName), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (goAnalysis()))
        }, {
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_table, {
        data: tableDate.value,
        border: "",
        stripe: "",
        style: {"width":"720px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "xjId",
            label: "序号",
            width: "180",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "xjName",
            label: "学姐",
            width: "180",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "xjScanNum",
            label: "次数",
            width: "180",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "xjChangeNum",
            label: "更换次数",
            width: "180",
            align: "center"
          })
        ]),
        _: 1
      }, 8, ["data"])
    ])
  ]))
}
}

})